import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {i18nMixin} from '@aofl/i18n-mixin';
import {storeInstance} from '@aofl/store/dist/legacy';

/**
 * @summary BulkActionsButton
 * @extends {AoflElement}
 */
@customElement('bulk-actions-button')
class BulkActionsButton extends AoflElement {
  /**
   * Creates an instance of BulkActionsButton.
   */
  constructor() {
    super();
  }

  @property({type: Number, attribute: false})
  ['total-results-count'] = 0;

  @property({type: String, attribute: false})
  ['selection-mode'] = '';

  @property({type: Number, attribute: false})
  ['not-selected-count'] = 0;

  @property({type: Number, attribute: false})
  ['persistent-selection-count'] = 0;

  @property({type: String, attribute: true})
  ['data-bi-id'] = '';

  @property({type: Boolean, attribute: false})
  loading = false;

  @property({type: Boolean, attribute: false})
  disabled = false;

  /**
   * @readonly
   */
  static is = 'bulk-actions-button';
  /**
   * @return {Object}
   */
  render() {
    return super.render(template, [styles]);
  }
}

export default BulkActionsButton;
